/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetEvBatteryManagementChargeResponse } from '../models/ApiResponseGetEvBatteryManagementChargeResponse';
import type { ApiResponseGetEvBatteryManagementScoreResponse } from '../models/ApiResponseGetEvBatteryManagementScoreResponse';
import type { ApiResponseGetEvBatteryManagementTripResponse } from '../models/ApiResponseGetEvBatteryManagementTripResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EvBatteryManagementControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 주행 컨텐츠 조회
   * 주행 컨텐츠 조회
   * @returns ApiResponseGetEvBatteryManagementTripResponse OK
   * @throws ApiError
   */
  public getEvBatteryManagementTrip({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryManagementTripResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/management/trip/',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 주행 컨텐츠 조회
   * 주행 컨텐츠 조회
   * @returns ApiResponseGetEvBatteryManagementTripResponse OK
   * @throws ApiError
   */
  public getEvBatteryManagementTrip1({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryManagementTripResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/management/trip',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 배터리 관리 점수 조회
   * 배터리 관리 점수 조회
   * @returns ApiResponseGetEvBatteryManagementScoreResponse OK
   * @throws ApiError
   */
  public getEvBatteryManagementScore({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryManagementScoreResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/management/scores/',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 배터리 관리 점수 조회
   * 배터리 관리 점수 조회
   * @returns ApiResponseGetEvBatteryManagementScoreResponse OK
   * @throws ApiError
   */
  public getEvBatteryManagementScore1({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryManagementScoreResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/management/scores',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 충전 컨텐츠 조회
   * 충전 컨텐츠 조회
   * @returns ApiResponseGetEvBatteryManagementChargeResponse OK
   * @throws ApiError
   */
  public getEvBatteryManagementCharge({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryManagementChargeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/management/charge',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
  /**
   * 충전 컨텐츠 조회
   * 충전 컨텐츠 조회
   * @returns ApiResponseGetEvBatteryManagementChargeResponse OK
   * @throws ApiError
   */
  public getEvBatteryManagementCharge1({
    vin,
    puid,
  }: {
    /**
     * 차대번호
     */
    vin: string,
    /**
     * puid
     */
    puid: string,
  }): CancelablePromise<ApiResponseGetEvBatteryManagementChargeResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/ev-battery/management/charge/',
      query: {
        'vin': vin,
        'puid': puid,
      },
    });
  }
}
